<template>
    <div class="flex justify-center">
        <div class="mt-10 p-4 items-center text-center deepLinkContent">
            <img src="@/assets/images/kangaroo.png" height="200" alt="Kangaroo" class="mb-5" />
            <h3 v-if="!isMobile">
                Sorry, you need to open this link on your mobile with the Wellful app installed.
            </h3>
            <h3>Download Wellful on your iOS or Android mobile device via the links below.</h3>
            <app-links class="flex flex-col items-center" />
        </div>
    </div>
</template>

<script>
import AppLinks from '../register/AppLinks.vue'

export default {
    name: 'deep-link-landing',
    computed: {
        tileIDFromURL() {
            return this.$route.params.tileIDFromURL
        }
    },
    data() {
        return {
            // navigator.userAgent is not reactive, hence there is no point in it being computed
            isMobile: /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
        }
    },
    mounted() {
        if (this.isMobile) {
            window.location = `zutak-wellful-wellful:navigation.navTo?tileUUID=${this.tileIDFromURL}`
        }
    },
    components: { AppLinks }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Barlow:wght@300;400;500;600;700;800&family=Playfair+Display:wght@400;500;600;700;800&display=swap');

.deepLinkContent {
    min-width: 320px;
    max-width: 768px;
}
h3 {
    color: rgb(124, 124, 124);
    line-height: 1.8;
    margin-bottom: 25px;
}
</style>
